

 $('.pincode-validate-btn').click(function(){
  var val = $('input.pincode').val();
  $(this).text('Loading...');
   $.ajax({
  // url: `https://redtape.com/index.php?route=api/pincode/checkPincode&code=${val}`,
  url: `https://redtape.ensdevops.com/pincode.php?code=${val}`,
  type: 'post',
  dataType: 'html',
  success: function(data) {
     var dataparse_update = JSON.parse(data);
    $('.delivery__success_main').html(dataparse_update.response);
    $('.pincode-validate-btn').text('CHECK');
    $('.icons__success').css('display','flex');
  }
  });
})